import { faBoxOpen, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import createField from "../../../../utils/factory/createField";

export const fixEquipmentFields = [
  {
    section: "Qual situação do equipamento?",
    fields: [
      createField({
        id: "equipment.situation",
        label: "Situação atual do equipamento",
        type: "select",
        placeholder: "Selecione a situação do equipamento",
        icon: faInfoCircle,
        disabled: true,
        fullWidth: true,
        options: null,
      }),
      createField({
        id: "equipment.equipment_id",
        label: "Equipamento",
        type: "select",
        placeholder: "Selecione o equipamento",
        icon: faBoxOpen,
        fullWidth: true,
        options: null,
      }),
    ],
  },
  // * Seção para atrelar equipamentos
  {
    section: "Equipamentos a serem atrelados",
    array: true,
    fields: [
      createField({
        id: "attached_equipment.equipment_id",
        label: "Equipamento a ser baixado",
        type: "select",
        placeholder: "Selecione o equipamento",
        icon: faInfoCircle,
        fullWidth: true,
      }),
    ],
  },
  // * Seção pra retombar equipamento
  {
    section: "Informações do insumo",
    array: true,
    fields: [
      createField({
        id: "productItem.name",
        label: "Produto",
        type: "text",
        placeholder: "Informe o nome do insumo",
        icon: faInfoCircle,
        disabled: true,
      }),
      createField({
        id: "productItem.category",
        label: "Categoria",
        type: "text",
        placeholder: "Informe a categoria",
        icon: faInfoCircle,
        disabled: true,
      }),
      createField({
        id: "productItem.condition",
        label: "Condição",
        type: "text",
        placeholder: "Informe a condição",
        disabled: true,
        icon: faInfoCircle,
      }),
      createField({
        id: "productItem.address",
        label: "Endereço",
        type: "text",
        placeholder: "Informe o endereço",
        icon: faInfoCircle,
        disabled: true,
      }),
    ],
  },
  {
    section: "Informações do equipamento",
    array: true,
    fields: [
      createField({
        id: "equipment.number",
        label: "Tombo",
        type: "text",
        placeholder: "Informe o número do tombo",
        icon: faInfoCircle,
      }),
      createField({
        id: "equipment.serial_number",
        label: "Série",
        type: "text",
        disabled: true,
        placeholder: "Informe o número de série",
        icon: faInfoCircle,
      }),
    ],
  },
];
